import { ViewConfig } from "@lib/views";
import { OrganizationCloseStageActionsCell } from "./cells/OrganizationCloseStageActionsCell";
import { OrganizationCloseStageNameCell } from "./cells/OrganizationCloseStageNameCell";
import { OrganizationCloseStageUpdatedCell } from "./cells/OrganizationCloseStageUpdatedCell";

export enum OrganizationCloseStageColumn {
    NAME = "name",
    UPDATED = "updated",
    ACTIONS = "actions",
}

export interface OrganizationCloseStageRow {
    id: string;
    name: string;
    updatedAt: Date;
    organizationId: string;
    parentCloseStageId: string | null;
    rootCloseStageId: string;
    order: number;
    children?: OrganizationCloseStageRow[];
}

export const organizationCloseStagesViewConfig: ViewConfig<
    OrganizationCloseStageRow,
    OrganizationCloseStageColumn,
    never
> = {
    columns: {
        [OrganizationCloseStageColumn.NAME]: {
            accessorKey: "name",
            name: "Name",
            header: "Name",
            cell: OrganizationCloseStageNameCell,
            minSize: 220,
            maxSize: 1200,
        },
        [OrganizationCloseStageColumn.UPDATED]: {
            accessorKey: "updatedAt",
            name: "Updated",
            header: "Updated",
            cell: OrganizationCloseStageUpdatedCell,
            minSize: 140,
            maxSize: 180,
        },
        [OrganizationCloseStageColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: OrganizationCloseStageActionsCell,
            minSize: 90,
            maxSize: 90,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
